/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OwnerType } from './';
import {
    OwnerTypeFromJSON,
    OwnerTypeFromJSONTyped,
    OwnerTypeToJSON,
} from './';
import type { UboDeclarationBeneficiaryAddress } from './';
import {
    UboDeclarationBeneficiaryAddressFromJSON,
    UboDeclarationBeneficiaryAddressFromJSONTyped,
    UboDeclarationBeneficiaryAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface UboDeclarationBeneficiaryResource
 */
export interface UboDeclarationBeneficiaryResource {
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationBeneficiaryResource
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationBeneficiaryResource
     */
    lastName: string;
    /**
     * 2 letter country code (ALPHA-2 ISO 3166)
     * @type {string}
     * @memberof UboDeclarationBeneficiaryResource
     */
    nationality: string;
    /**
     * 
     * @type {Date}
     * @memberof UboDeclarationBeneficiaryResource
     */
    birthday: Date;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationBeneficiaryResource
     */
    birthPlaceCity: string;
    /**
     * 2 letter country code (ALPHA-2 ISO 3166)
     * @type {string}
     * @memberof UboDeclarationBeneficiaryResource
     */
    birthPlaceCountry: string;
    /**
     * 
     * @type {UboDeclarationBeneficiaryAddress}
     * @memberof UboDeclarationBeneficiaryResource
     */
    address: UboDeclarationBeneficiaryAddress;
    /**
     * 
     * @type {OwnerType}
     * @memberof UboDeclarationBeneficiaryResource
     */
    ownerType?: OwnerType;
    /**
     * 
     * @type {number}
     * @memberof UboDeclarationBeneficiaryResource
     */
    ownerShare?: number;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationBeneficiaryResource
     */
    ownerRight?: string;
}

/**
 * Check if a given object implements the UboDeclarationBeneficiaryResource interface.
 */
export function instanceOfUboDeclarationBeneficiaryResource(value: object): value is UboDeclarationBeneficiaryResource {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('nationality' in value) || value['nationality'] === undefined) return false;
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    if (!('birthPlaceCity' in value) || value['birthPlaceCity'] === undefined) return false;
    if (!('birthPlaceCountry' in value) || value['birthPlaceCountry'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function UboDeclarationBeneficiaryResourceFromJSON(json: any): UboDeclarationBeneficiaryResource {
    return UboDeclarationBeneficiaryResourceFromJSONTyped(json, false);
}

export function UboDeclarationBeneficiaryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboDeclarationBeneficiaryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'nationality': json['nationality'],
        'birthday': (new Date(json['birthday'])),
        'birthPlaceCity': json['birthPlaceCity'],
        'birthPlaceCountry': json['birthPlaceCountry'],
        'address': UboDeclarationBeneficiaryAddressFromJSON(json['address']),
        'ownerType': json['ownerType'] == null ? undefined : OwnerTypeFromJSON(json['ownerType']),
        'ownerShare': json['ownerShare'] == null ? undefined : json['ownerShare'],
        'ownerRight': json['ownerRight'] == null ? undefined : json['ownerRight'],
    };
}

export function UboDeclarationBeneficiaryResourceToJSON(value?: UboDeclarationBeneficiaryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'nationality': value['nationality'],
        'birthday': ((value['birthday']).toISOString()),
        'birthPlaceCity': value['birthPlaceCity'],
        'birthPlaceCountry': value['birthPlaceCountry'],
        'address': UboDeclarationBeneficiaryAddressToJSON(value['address']),
        'ownerType': OwnerTypeToJSON(value['ownerType']),
        'ownerShare': value['ownerShare'],
        'ownerRight': value['ownerRight'],
    };
}

